import { render, staticRenderFns } from "./course_list.vue?vue&type=template&id=36cd62a0&scoped=true&"
import script from "./course_list.vue?vue&type=script&lang=ts&"
export * from "./course_list.vue?vue&type=script&lang=ts&"
import style0 from "./course_list.vue?vue&type=style&index=0&id=36cd62a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd62a0",
  null
  
)

export default component.exports